import { all, put, takeLatest } from 'redux-saga/effects';

import { types } from '../ducks/findGuideLines';

export function * watchFindGuideLines() {
    yield takeLatest(types.FINDGUIDELINES_GET, onFindGuideLinesGet);
    yield takeLatest(types.FINDGUIDELINES_SUCCESS, onFindGuideLinesResponse);
}

export function * onFindGuideLinesGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onFindGuideLinesResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'findGuideLines') {
        return yield all([
            put({
                type: types.FINDGUIDELINES_GET,
                payload: response,
            }),
        ]);
    }
}
